function storeNotice() {
	const notice = document.querySelector('.woocommerce-store-notice');
	const headerEl = document.querySelector('header.store_notice');

	if (!notice || !headerEl) return;

	const updateTop = () => {
		headerEl.style.top = notice.offsetHeight + 'px';
	};

	updateTop();

	const observer = new ResizeObserver(updateTop);
	observer.observe(notice);
}

export { storeNotice };
